import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ModalStyle } from './Util';
import './priceModal.scss';

const PriceModalComponent = ({text}) => {

    return (
        <div>
            <Box sx={ModalStyle}>
                <Typography id='modal-modal-description' sx={{mt: 2}}>
                    <div>
                        {text}
                    </div>

                    <div className={'buttons'}>
                        <a href='https://t.me/zakovat_savollari_com' target={'_blank'}>Telegram - Bot</a>
                        <a href='https://t.me/zakovat_savollari_com' target={'_blank'}>Telegram - Admin</a>
                    </div>
                </Typography>
            </Box>
        </div>
    );
};

export default PriceModalComponent;
